import { usePublicLanguage } from "../../context/PublicLanguage";
import React from "react";

export default function AdSlot({ label = "Advertisement", height = 120, className = "" }) {
  const { t } = usePublicLanguage();
  return (
    <div
      className={`rounded-md border flex flex-col items-center justify-center text-center ${className}`}
      style={{ borderColor: "rgba(255,255,255,0.07)", background: "#0c0d0e", minHeight: height, borderStyle: "dashed" }}
      data-testid="ad-slot"
    >
      <span className="td-eyebrow" style={{ color: "#4a4e52", fontSize: "0.56rem" }}>
        {t(label)}
      </span>
      <span className="text-[#3a3d40] text-xs mt-1 font-mono-td">{t('reserved slot')}</span>
    </div>
  );
}
